import { Component, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";

import { MatDialog } from "@angular/material/dialog";
import { UserService } from "../services/user.service";
import { User } from "../models/user";
import { CompanylinkedService } from "../services/companylinked.service";
import { CompanyLinked } from "../models/companylinked";
import swal from "sweetalert2";
import { Folder } from "../models/folder";
import { LocationService } from "../services/location.service";
import { WareHouse } from "../models/warehouse";
import { TermService } from "../services/saleterm.service";
import { PurchaseTermService } from "../services/purchaseterms.service";
import { ConditionService } from "../services/condition.service";
import { CurrencyService } from "../services/currency.service";
import { TaxService } from "../services/tax.service";
import { ContactsComponent } from "../contacts/contacts.component";
import { NuevoPaciente } from "../customers/customers.component";
import { FolderService } from "../services/folder.service";
import { CategoriesService } from "../services/categories.service";
import { VendorService } from "../services/vendor.service";
import { ContactPartyPickupService } from "../services/contactpartypickup.service";
import { Methods } from "../shared/methods";
import { VendorComponent } from "../modulos/vendors/vendor/vendor.component";
import { GuiGuard } from "../shared/guard/base-gui-guard";
import { ErasuremethodService } from "../services/erasuremethod.service";
import { CompanyService } from "src/app/services/company.service";
import { Cell, DinamicData } from "../models/dinamic-data";
import { LoadingComponent } from "../shared/components/loading/loading.component";
import { ConfigService } from "../services/config.service";
import { MatStepper } from "@angular/material/stepper";
import JSZip from "jszip";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { Title } from "@angular/platform-browser";
import { TitleService } from "../services/title.service";
import { FormControl } from "@angular/forms";
import { AutocompleteOption } from "src/app/ui-components";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { ChangeDetectorRef } from "@angular/core";
declare const require: any;

declare const $: any;

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

declare interface Valid {
  status: string;
  code: number;
  msg: string;
}

interface FileReaderEventTarget extends EventTarget {
  result: string;
}

interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage(): string;
}

export interface UserList {
  value: string;
  name: string;
}

@Component({
  selector: "app-company-cmp",
  templateUrl: "company.component.html",
  styleUrls: ["./company.component.scss"],
  providers: [
    UserService,
    CompanylinkedService,
    LocationService,
    TermService,
    ConditionService,
    CurrencyService,
    PurchaseTermService,
    ContactPartyPickupService,
    GuiGuard,
  ],
})
export class CompanyComponent implements OnInit, AfterViewInit {
  countryControl = new FormControl();
  stateControl = new FormControl();
  @ViewChild(MatStepper) stepper!: MatStepper;

  public identity;
  public token;
  public privilegio;

  public tableContacts: DataTable;

  public loading;

  //public contacts;

  public dataTable: DataTable;
  public pacientes: Array<User>;
  public idUser;

  public user: CompanyLinked;
  //public user;
  public bulkItems: any[] = [];

  public pages;
  public pagePrev;
  public pageNext;
  public filter = 0;
  public order = 0;
  public searchString;
  public status_user;
  // public totalFiles;
  //3rd Party Pickup
  public enable3rd = false;
  public enableVIP: any = 0;
  public enableDefault = false;
  public contactsPartyPickup: any[] = [];
  public nameContactPickup;
  public emailContactPickup;
  public phoneContactPickup;
  public showContactPickup;
  public newContactPickup;
  public editContactPickup;
  public saving;
  public loadingContacts = false;
  public contactPickupId;

  // public tableLocations: DataTable;
  public locationsData: DinamicData = new DinamicData([
    "check",
    "ID",
    "Default",
    "Name",
    "Address",
    "Address 2",
    "State",
    "City",
    "Zip Code",
    "Country",
    "Actions",
  ]);

  public locations: any[] = [];

  public location: WareHouse;

  public locationId;

  public terms: any[] = [];
  public purchassingTerms: any[] = [];
  public conditions: any[] = [];
  public currencies: any[] = [];

  public loadinglocation = false;
  public loadingStates = false;
  public loadingStates2 = false;
  public states: any[] = [];
  public states2: any[] = [];
  public industryTypes;
  public industry;
  public optionsButtonSelect;
  public optionSelectMenuTrigger;
  public activos = 1;
  public cargando = false;
  public startDate = "";
  public endDate = "";
  public start = "";
  public end = "";
  public active_inactive = 1;
  public dateInitial = "";
  public idCompany = "";
  public stateCert = false;
  public stateDate = false;
  public stateModal = false;
  public stateDateCer = false;
  public showContactForm = false;
  public reloadKey = 0;
  public staffData: DinamicData = new DinamicData([
    "check",
    "ID",
    "Rep Name",
    "Title",
    "Name",
    "State",
    "City",
    "Type",
    "Actions",
  ]);
  public page = 1;
  public pageLimit = "10";
  public totalItems = 0;
  public totalPaginas = 1;
  public valid: Valid = {
    status: "",
    code: null,
    msg: "",
  };

  public tableUsers: boolean = true;

  // public countries: any[] = [
  //   { id: 1, name: "UNITED STATES", value: "US" },
  //   { id: 2, name: "MEXICO", value: "MX" },
  //   { id: 3, name: "AFGHANISTAN", value: "AF" },
  //   { id: 4, name: "ALBANIA", value: "AL" },
  //   { id: 5, name: "ALGERIA", value: "DZ" },
  //   { id: 6, name: "AMERICAN SAMOA", value: "AS" },
  //   { id: 7, name: "ANDORRA", value: "AD" },
  //   { id: 8, name: "ANGOLA", value: "AO" },
  //   { id: 9, name: "ANGUILLA", value: "AI" },
  //   { id: 10, name: "ANTARCTICA", value: "AQ" },
  //   { id: 11, name: "ANTIGUA AND BARBUDA", value: "AG" },
  //   { id: 12, name: "ARGENTINA", value: "AR" },
  //   { id: 13, name: "ARMENIA", value: "AM" },
  //   { id: 14, name: "ARUBA", value: "AW" },
  //   { id: 15, name: "AUSTRALIA", value: "AU" },
  //   { id: 16, name: "AUSTRIA", value: "AT" },
  //   { id: 17, name: "AZERBAIJAN", value: "AZ" },
  //   { id: 18, name: "BAHAMAS", value: "BS" },
  //   { id: 19, name: "BAHRAIN", value: "BH" },
  //   { id: 20, name: "BANGLADESH", value: "BD" },
  //   { id: 21, name: "BARBADOS", value: "BB" },
  //   { id: 22, name: "BELARUS", value: "BY" },
  //   { id: 23, name: "BELGIUM", value: "BE" },
  //   { id: 24, name: "BELIZE", value: "BZ" },
  //   { id: 25, name: "BENIN", value: "BJ" },
  //   { id: 26, name: "BERMUDA", value: "BM" },
  //   { id: 27, name: "BHUTAN", value: "BT" },
  //   { id: 28, name: "BOLIVIA", value: "BO" },
  //   { id: 29, name: "BOSNIA AND HERZEGOVINA", value: "BA" },
  //   { id: 30, name: "BOTSWANA", value: "BW" },
  //   { id: 31, name: "BOUVET ISLAND", value: "BV" },
  //   { id: 32, name: "BRAZIL", value: "BR" },
  //   { id: 33, name: "BRITISH INDIAN OCEAN TERRITORY", value: "IO" },
  //   { id: 34, name: "BRUNEI DARUSSALAM", value: "BN" },
  //   { id: 35, name: "BULGARIA", value: "BG" },
  //   { id: 36, name: "BURKINA FASO", value: "BF" },
  //   { id: 37, name: "BURUNDI", value: "BI" },
  //   { id: 38, name: "CAMBODIA", value: "KH" },
  //   { id: 39, name: "CAMEROON", value: "CM" },
  //   { id: 40, name: "CANADA", value: "CA" },
  //   { id: 41, name: "CAPE VERDE", value: "CV" },
  //   { id: 42, name: "CAYMAN ISLANDS", value: "KY" },
  //   { id: 43, name: "CENTRAL AFRICAN REPUBLIC", value: "CF" },
  //   { id: 44, name: "CHAD", value: "TD" },
  //   { id: 45, name: "CHILE", value: "CL" },
  //   { id: 46, name: "CHINA", value: "CN" },
  //   { id: 47, name: "CHRISTMAS ISLAND", value: "CX" },
  //   { id: 48, name: "COCOS (KEELING) ISLANDS", value: "CC" },
  //   { id: 49, name: "COLOMBIA", value: "CO" },
  //   { id: 50, name: "COMOROS", value: "KM" },
  //   { id: 51, name: "CONGO", value: "CG" },
  //   {
  //     id: 52,
  //     name: "CONGO, THE DEMOCRATIC REPUBLIC OF THE CONGO",
  //     value: "CD",
  //   },
  //   { id: 53, name: "COOK ISLANDS", value: "CK" },
  //   { id: 54, name: "COSTA RICA", value: "CR" },
  //   { id: 55, name: "COTE D'IVOIRE", value: "CI" },
  //   { id: 56, name: "CROATIA", value: "HR" },
  //   { id: 57, name: "CUBA", value: "CU" },
  //   { id: 58, name: "CYPRUS", value: "CY" },
  //   { id: 59, name: "CZECH REPUBLIC", value: "CZ" },
  //   { id: 60, name: "DENMARK", value: "DK" },
  //   { id: 61, name: "DJIBOUTI", value: "DJ" },
  //   { id: 62, name: "DOMINICA", value: "DM" },
  //   { id: 63, name: "DOMINICAN REPUBLIC", value: "DO" },
  //   { id: 64, name: "ECUADOR", value: "EC" },
  //   { id: 65, name: "EGYPT", value: "EG" },
  //   { id: 66, name: "EL SALVADOR", value: "SV" },
  //   { id: 67, name: "EQUATORIAL GUINEA", value: "GQ" },
  //   { id: 68, name: "ERITREA", value: "ER" },
  //   { id: 69, name: "ESTONIA", value: "EE" },
  //   { id: 70, name: "ETHIOPIA", value: "ET" },
  //   { id: 71, name: "FALKLAND ISLANDS (MALVINAS)", value: "FK" },
  //   { id: 72, name: "FAROE ISLANDS", value: "FO" },
  //   { id: 73, name: "FIJI", value: "FJ" },
  //   { id: 74, name: "FINLAND", value: "FI" },
  //   { id: 75, name: "FRANCE", value: "FR" },
  //   { id: 76, name: "FRENCH GUIANA", value: "GF" },
  //   { id: 77, name: "FRENCH POLYNESIA", value: "PF" },
  //   { id: 78, name: "FRENCH SOUTHERN TERRITORIES", value: "TF" },
  //   { id: 79, name: "GABON", value: "GA" },
  //   { id: 80, name: "GAMBIA", value: "GM" },
  //   { id: 81, name: "GEORGIA", value: "GE" },
  //   { id: 82, name: "GERMANY", value: "DE" },
  //   { id: 83, name: "GHANA", value: "GH" },
  //   { id: 84, name: "GIBRALTAR", value: "GI" },
  //   { id: 85, name: "GREECE", value: "GR" },
  //   { id: 86, name: "GREENLAND", value: "GL" },
  //   { id: 87, name: "GRENADA", value: "GD" },
  //   { id: 88, name: "GUADELOUPE", value: "GP" },
  //   { id: 89, name: "GUAM", value: "GU" },
  //   { id: 90, name: "GUATEMALA", value: "GT" },
  //   { id: 91, name: "GUINEA", value: "GN" },
  //   { id: 92, name: "GUINEA-BISSAU", value: "GW" },
  //   { id: 93, name: "GUYANA", value: "GY" },
  //   { id: 94, name: "HAITI", value: "HT" },
  //   { id: 95, name: "HEARD ISLAND AND MCDONALD ISLANDS", value: "HM" },
  //   { id: 96, name: "HOLY SEE (VATICAN CITY STATE)", value: "VA" },
  //   { id: 97, name: "HONDURAS", value: "HN" },
  //   { id: 98, name: "HONG KONG", value: "HK" },
  //   { id: 99, name: "HUNGARY", value: "HU" },
  //   { id: 100, name: "ICELAND", value: "IS" },
  //   { id: 101, name: "INDIA", value: "IN" },
  //   { id: 102, name: "INDONESIA", value: "ID" },
  //   { id: 103, name: "IRAN, ISLAMIC REPUBLIC OF", value: "IR" },
  //   { id: 104, name: "IRAQ", value: "IQ" },
  //   { id: 105, name: "IRELAND", value: "IE" },
  //   { id: 106, name: "ISRAEL", value: "IL" },
  //   { id: 107, name: "ITALY", value: "IT" },
  //   { id: 108, name: "JAMAICA", value: "JM" },
  //   { id: 109, name: "JAPAN", value: "JP" },
  //   { id: 110, name: "JORDAN", value: "JO" },
  //   { id: 111, name: "KAZAKHSTAN", value: "KZ" },
  //   { id: 112, name: "KENYA", value: "KE" },
  //   { id: 113, name: "KIRIBATI", value: "KI" },
  //   { id: 114, name: "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF", value: "KP" },
  //   { id: 115, name: "KOREA, REPUBLIC OF", value: "KR" },
  //   { id: 116, name: "KUWAIT", value: "KW" },
  //   { id: 117, name: "KYRGYZSTAN", value: "KG" },
  //   { id: 118, name: "LAO PEOPLE'S DEMOCRATIC REPUBLIC", value: "LA" },
  //   { id: 119, name: "LATVIA", value: "LV" },
  //   { id: 120, name: "LEBANON", value: "LB" },
  //   { id: 121, name: "LESOTHO", value: "LS" },
  //   { id: 122, name: "LIBERIA", value: "LR" },
  //   { id: 123, name: "LIBYAN ARAB JAMAHIRIYA", value: "LY" },
  //   { id: 124, name: "LIECHTENSTEIN", value: "LI" },
  //   { id: 125, name: "LITHUANIA", value: "LT" },
  //   { id: 126, name: "LUXEMBOURG", value: "LU" },
  //   { id: 127, name: "MACAO", value: "MO" },
  //   {
  //     id: 128,
  //     name: "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF",
  //     value: "MK",
  //   },
  //   { id: 129, name: "MADAGASCAR", value: "MG" },
  //   { id: 130, name: "MALAWI", value: "MW" },
  //   { id: 131, name: "MALAYSIA", value: "MY" },
  //   { id: 132, name: "MALDIVES", value: "MV" },
  //   { id: 133, name: "MALI", value: "ML" },
  //   { id: 134, name: "MALTA", value: "MT" },
  //   { id: 135, name: "MARSHALL ISLANDS", value: "MH" },
  //   { id: 136, name: "MARTINIQUE", value: "MQ" },
  //   { id: 137, name: "MAURITANIA", value: "MR" },
  //   { id: 138, name: "MAURITIUS", value: "MU" },
  //   { id: 139, name: "MAYOTTE", value: "YT" },
  //   // {id: 140, name: 'MICRONESIA, FEDERATED STATES OF', value: ''},
  //   // {id: 141, name: 'MOLDOVA, REPUBLIC OF', value: ''},
  //   { id: 142, name: "MONACO", value: "MC" },
  //   { id: 143, name: "MONGOLIA", value: "MN" },
  //   { id: 144, name: "MONTSERRAT", value: "MS" },
  //   { id: 145, name: "MOROCCO", value: "MA" },
  //   { id: 146, name: "MOZAMBIQUE", value: "MZ" },
  //   { id: 147, name: "MYANMAR", value: "MM" },
  //   { id: 148, name: "NAMIBIA", value: "NA" },
  //   { id: 149, name: "NAURU", value: "NR" },
  //   { id: 150, name: "NEPAL", value: "NP" },
  //   { id: 151, name: "NETHERLANDS", value: "NL" },
  //   { id: 152, name: "NETHERLANDS ANTILLES", value: "AN" },
  //   { id: 153, name: "NEW CALEDONIA", value: "NC" },
  //   { id: 154, name: "NEW ZEALAND", value: "NZ" },
  //   { id: 155, name: "NICARAGUA", value: "NI" },
  //   { id: 156, name: "NIGER", value: "NE" },
  //   { id: 157, name: "NIGERIA", value: "NG" },
  //   { id: 158, name: "NIUE", value: "NU" },
  //   { id: 159, name: "NORFOLK ISLAND", value: "NF" },
  //   { id: 160, name: "NORTHERN MARIANA ISLANDS", value: "MP" },
  //   { id: 161, name: "NORWAY", value: "NO" },
  //   { id: 162, name: "OMAN", value: "OM" },
  //   { id: 163, name: "PAKISTAN", value: "PK" },
  //   { id: 164, name: "PALAU", value: "PW" },
  //   { id: 165, name: "PALESTINIAN TERRITORY, OCCUPIED", value: "PS" },
  //   { id: 166, name: "PANAMA", value: "PA" },
  //   { id: 167, name: "PAPUA NEW GUINEA", value: "PG" },
  //   { id: 168, name: "PARAGUAY", value: "PY" },
  //   { id: 169, name: "PERU", value: "PE" },
  //   { id: 170, name: "PHILIPPINES", value: "PH" },
  //   { id: 171, name: "PITCAIRN", value: "PN" },
  //   { id: 172, name: "POLAND", value: "PL" },
  //   { id: 173, name: "PORTUGAL", value: "PT" },
  //   { id: 174, name: "PUERTO RICO", value: "PR" },
  //   { id: 175, name: "QATAR", value: "QA" },
  //   { id: 176, name: "REUNION", value: "RE" },
  //   { id: 177, name: "ROMANIA", value: "RO" },
  //   { id: 178, name: "RUSSIAN FEDERATION", value: "RU" },
  //   { id: 179, name: "RWANDA", value: "RW" },
  //   { id: 180, name: "SAINT HELENA", value: "SH" },
  //   { id: 181, name: "SAINT KITTS AND NEVIS", value: "KN" },
  //   { id: 182, name: "SAINT LUCIA", value: "LC" },
  //   { id: 183, name: "SAINT PIERRE AND MIQUELON", value: "PM" },
  //   { id: 184, name: "SAINT VINCENT AND THE GRENADINES", value: "VC" },
  //   { id: 185, name: "SAMOA", value: "WS" },
  //   { id: 186, name: "SAN MARINO", value: "SM" },
  //   { id: 187, name: "SAO TOME AND PRINCIPE", value: "ST" },
  //   { id: 188, name: "SAUDI ARABIA", value: "SA" },
  //   { id: 189, name: "SENEGAL", value: "SN" },
  //   { id: 190, name: "SERBIA AND MONTENEGRO", value: "CS" },
  //   { id: 191, name: "SEYCHELLES", value: "SC" },
  //   { id: 192, name: "SIERRA LEONE", value: "SL" },
  //   { id: 193, name: "SINGAPORE", value: "SG" },
  //   { id: 194, name: "SLOVAKIA", value: "SK" },
  //   { id: 195, name: "SLOVENIA", value: "SI" },
  //   { id: 196, name: "SOLOMON ISLANDS", value: "SB" },
  //   { id: 197, name: "SOMALIA", value: "SO" },
  //   { id: 198, name: "SOUTH AFRICA", value: "ZA" },
  //   {
  //     id: 199,
  //     name: "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS",
  //     value: "GS",
  //   },
  //   { id: 200, name: "SPAIN", value: "ES" },
  //   { id: 201, name: "SRI LANKA", value: "LK" },
  //   { id: 202, name: "SUDAN", value: "SD" },
  //   { id: 203, name: "SURINAME", value: "SR" },
  //   { id: 204, name: "SVALBARD AND JAN MAYEN", value: "SJ" },
  //   { id: 205, name: "SWAZILAND", value: "SZ" },
  //   { id: 206, name: "SWEDEN", value: "SE" },
  //   { id: 207, name: "SWITZERLAND", value: "CH" },
  //   { id: 208, name: "SYRIAN ARAB REPUBLIC", value: "SY" },
  //   { id: 209, name: "TAIWAN, PROVINCE OF CHINA", value: "TW" },
  //   { id: 210, name: "TAJIKISTAN", value: "TJ" },
  //   { id: 211, name: "TANZANIA, UNITED REPUBLIC OF", value: "TZ" },
  //   { id: 212, name: "THAILAND", value: "TH" },
  //   { id: 213, name: "TIMOR-LESTE", value: "TL" },
  //   { id: 214, name: "TOGO", value: "TG" },
  //   { id: 215, name: "TOKELAU", value: "TK" },
  //   { id: 216, name: "TONGA", value: "TO" },
  //   { id: 217, name: "TRINIDAD AND TOBAGO", value: "TT" },
  //   { id: 218, name: "TUNISIA", value: "TN" },
  //   { id: 219, name: "TURKEY", value: "TR" },
  //   { id: 220, name: "TURKMENISTAN", value: "TM" },
  //   { id: 221, name: "TURKS AND CAICOS ISLANDS", value: "TC" },
  //   { id: 222, name: "TUVALU", value: "TV" },
  //   { id: 223, name: "UGANDA", value: "UG" },
  //   { id: 224, name: "UKRAINE", value: "UA" },
  //   { id: 225, name: "UNITED ARAB EMIRATES", value: "AE" },
  //   { id: 226, name: "UNITED KINGDOM", value: "GB" },
  //   { id: 227, name: "UNITED STATES MINOR OUTLYING ISLANDS", value: "UM" },
  //   { id: 228, name: "URUGUAY", value: "UY" },
  //   { id: 229, name: "UZBEKISTAN", value: "UZ" },
  //   { id: 230, name: "VANUATU", value: "VU" },
  //   { id: 231, name: "VENEZUELA", value: "VE" },
  //   { id: 232, name: "VIET NAM", value: "VN" },
  //   { id: 233, name: "VIRGIN ISLANDS, BRITISH", value: "VG" },
  //   { id: 234, name: "VIRGIN ISLANDS, U.S.", value: "VI" },
  //   { id: 235, name: "WALLIS AND FUTUNA", value: "WF" },
  //   { id: 236, name: "WESTERN SAHARA", value: "EH" },
  //   { id: 237, name: "YEMEN", value: "YE" },
  //   { id: 238, name: "ZAMBIA", value: "ZM" },
  //   { id: 239, name: "ZIMBABWE", value: "ZW" },
  // ];

  public erasureMethods = [];

  constructor(
    public dialog: MatDialog,
    private _userService: UserService,
    private _companylinkedService: CompanylinkedService,
    private _locationService: LocationService,
    private _termService: TermService,
    private _purchassingTermsService: PurchaseTermService,
    private _conditionService: ConditionService,
    private _currencyService: CurrencyService,
    private _route: ActivatedRoute,
    private _taxService: TaxService,
    private _router: Router,
    private _folderService: FolderService,
    private _cattegorieServices: CategoriesService,
    private _service: VendorService,
    private _erasureService: ErasuremethodService,
    private _contactPartyPickupService: ContactPartyPickupService,
    public guard: GuiGuard,
    private _companyService: CompanyService,
    private _config: ConfigService,
    private titleService: Title,
    private titleServices: TitleService
  ) {
    this.titleService.setTitle("Company");

    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    console.log(this.privilegio);
    if (this.privilegio.level == "VENDOR") {
      this._router.navigate(["/dashboard"]);
    }
    this.identity = this._userService.getIdentity();

    if (this.identity == null) {
      localStorage.clear();
      this._router.navigate(["/pages/lock"]);
    }

    this.token = this._userService.getToken();

    this._route.params.forEach((params: Params) => {
      this.idUser = params["id"];
      console.log("iduser: " + this.idUser);
    });

    this.status_user = "";
    this.location = new WareHouse(
      1,
      null,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      1,
      "",
      ""
    );

    this._erasureService.showAll().subscribe((response) => {
      console.log(response);
      this.erasureMethods = response.data;
    });
  }
  cambiarActivos() {
    if (this.activos === 1) {
      this.activos = 0;
    } else {
      this.activos = 1;
    }

    this.getAllPacientes();
  }
  menuTriggerToShow(newValue: string) {
    if (newValue === "Active") {
      this.activos = 0;
    } else {
      this.activos = 1;
    }
    this.cambiarActivos();
  }
  public disableCountry = false;
  ngOnInit() {
    this.cargando = true;
    this.optionsButtonSelect = [
      { value: "Active", label: "Active" },
      { value: "Inactive", label: "Inactive" },
    ];
    this.optionSelectMenuTrigger = "Active";
    if (this.identity == null && this.identity.sub) {
      localStorage.clear();
      this._router.navigate(["/pages/lock"]);
    } else {
      console.log("ngOnInit");

      // this.getAllPacientes();
      // this.getLocations();
      this.getTerms();
      this.getPurchassingTerms();
      this.getConditions();
      this.getCurrencies();
      this.getUser();
      this.getContactPartyPickup();
      this.getTypeIndustry();
      this.disableCountry = true;
      this.myControlUserCountries.disable();
      this.myControlStatesAddress.disable();
      this._config.getConfig("taxList").subscribe(
        (r) => {
          if (r.data) {
            this.config = JSON.parse(r.data.data);
          } else {
            this.config = this.mtds.colopt(this.taxData.headers, [false]);
          }
          this.getListTax();
        },
        (error) => {
          this.mtds.notifyError(error.statusText, error.status);
          this.loading = false;
        }
      );
      this._config.getConfig("staffList").subscribe(
        (r) => {
          if (r.data) {
            this.configStaff = JSON.parse(r.data.data);
          } else {
            this.configStaff = this.mtds.colopt(this.staffData.headers, [
              false,
            ]);
          }
          this.getAllPacientes();
        },
        (error) => {
          this.mtds.notifyError(error.statusText, error.status);
          this.loading = false;
        }
      );
      this._config.getConfig("locationsList").subscribe(
        (r) => {
          if (r.data) {
            this.configLoc = JSON.parse(r.data.data);
          } else {
            this.configLoc = this.mtds.colopt(this.locationsData.headers, [
              false,
            ]);
          }
          this.getListLocations();
        },
        (error) => {
          this.mtds.notifyError(error.statusText, error.status);
          this.loading = false;
        }
      );
    }
  }

  public isEditCompany = false;
  public formatedCountries = [];
  public formatedCountriesLocation = [];
  public isEditHq = false;
  public isEditSettings = false;
  cancelForm(type) {
    this.getUser();

    switch (type) {
      case "company":
        this.editCompany = false;
        break;
      case "hq":
        this.editAddress = false;
        this.myControlUserCountries.disable();
        this.myControlStatesAddress.disable();
        break;
      case "settings":
        this.editSettings = false;
        break;

      default:
        break;
    }
  }
  // public states: any[] = [];
  public countries;
  public country_id;
  filteredCountries: Observable<UserList[]>;
  filteredUserCountries: Observable<UserList[]>;
  filteredStates: Observable<UserList[]>;
  filteredStatesAddress: Observable<UserList[]>;
  myControlCountries = new FormControl();
  myControlStates = new FormControl();
  myControlStatesAddress = new FormControl();
  myControlUserCountries = new FormControl();

  private _filterCountries(name: string): UserList[] {
    const filterValue = name;

    return this.countries.filter((option) =>
      String(option.name).toLowerCase().startsWith(filterValue)
    );
  }
  private _filterUserCountries(name: string): UserList[] {
    const filterValue = name;

    return this.countries.filter((option) =>
      String(option.name).toLowerCase().startsWith(filterValue)
    );
  }
  private _filterStates(name: string): UserList[] {
    const filterValue = name;

    return this.states.filter((option) =>
      String(option.name).toLowerCase().startsWith(filterValue)
    );
  }

  public loadingCountries = false;
  getCountries() {
    this._taxService.getCountries().subscribe((r) => {
      this.loadingCountries = true;
      if (r.status == "success") {
        this.loadingCountries = false;
        this.countries = r.data;
        if (this.countries) {
          this.filteredCountries = this.myControlCountries.valueChanges.pipe(
            startWith<string | UserList>(""),
            map((value) => (typeof value === "string" ? value : value.name)),
            map((name) =>
              name ? this._filterCountries(name) : this.countries.slice()
            )
          );
          this.filteredUserCountries =
            this.myControlUserCountries.valueChanges.pipe(
              startWith<string | UserList>(""),
              map((value) => (typeof value === "string" ? value : value.name)),
              map((name) =>
                name ? this._filterUserCountries(name) : this.countries.slice()
              )
            );
        }

        if (this.location.country) {
          const foundCountry = this.countries.find(
            (c) => c.name === this.location.country
          );
          if (foundCountry) {
            this.myControlCountries.setValue(foundCountry);
          }
          this.getStates(foundCountry.name);
        } else {
          if (this.user) {
            // console.log("llega acá", this.user?.country);
            const foundCountry = this.countries.find(
              (c) => c.name === this.formatName(this.user.country)
            );
            if (foundCountry) {
              this.myControlCountries.setValue(foundCountry);
              this.myControlUserCountries.setValue(foundCountry);
            }
            this.getStates(foundCountry.name);
          }
        }
      } else {
        console.log(r.status, "error countries");
      }
    });
  }
  //  filterCountries(value: string | any) {
  //   const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.name?.toLowerCase() || '';
  //   this.filteredCountries = this.countries.filter(country =>
  //     country.name.toLowerCase().includes(filterValue)
  //   );
  // }
  ngOnChanges() {
    if (this.editAddress) {
      this.myControlUserCountries.enable();
    } else {
      this.myControlUserCountries.disable();
    }
  }
  displayCountry(country: any): string {
    return country?.name || "";
  }

  onCountrySelected(country: any) {
    this.location.country = country.name;
    console.log("País seleccionado:", country);
    this.getStates(this.location.country);
  }
  onCountrySelectedUser(country: any) {
    this.user.country = country.name;
    console.log("País seleccionado:", country);
    this.getStates(this.user.country);
  }
  onStateSelected(state: any) {
    this.location.colonia = state.abbr;
  }
  onStateSelectedAddress(state: any) {
    console.log(state, "mystate");
    this.user.colonia = state.abbr;
  }
  displayState(state: any): string {
    return state ? `${state.abbr} - ${state.name}` : "";
  }
  stat(e) {
    console.log(e, "evenht");
  }
  formatName(name: string): string {
    if (!name) return "";
    return name
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  public editAddress = false;
  toggleAction(event: any): void {
    if (event.checked) {
      this.editAddress = true;
      this.myControlUserCountries.enable();
      this.myControlStatesAddress.enable();
    } else {
      this.myControlUserCountries.disable();
      this.myControlStatesAddress.disable();

      this.editAddress = false;
    }
  }
  public editSettings = false;

  toggleActionSettings(event: any): void {
    if (event.checked) {
      this.editSettings = true;
    } else {
      this.editSettings = false;
    }
  }
  public editCompany = false;

  toggleActionCompany(event: any): void {
    if (event.checked) {
      this.editCompany = true;
    } else {
      this.editCompany = false;
    }
  }
  openNewModalContactParty() {
    this.nameContactPickup = "";
    this.emailContactPickup = "";
    this.phoneContactPickup = "";
    this.showContactPickup = false;
    this.editContactPickup = false;
    this.newContactPickup = true;
    $("#myModalContactPickup").modal("show");
  }

  action(e) {
    console.log(e);
    switch (e.evento) {
      case "showContactParty": {
        this.openViewModal(e.id, e.evento);
        break;
      }
      case "editContactParty": {
        this.openViewModal(e.id, e.evento);
        break;
      }
      case "deleteContactParty": {
        this.deleteModalContact(e.id);
        break;
      }
      default:
        break;
    }
  }

  openViewModal(contact, action) {
    if (action == "showContactParty") {
      this.newContactPickup = false;
      this.editContactPickup = false;
      this.showContactPickup = true;
    } else {
      this.newContactPickup = false;
      this.showContactPickup = false;
      this.editContactPickup = true;
    }

    this.contactPickupId = contact;
    this.loading = true;
    this._contactPartyPickupService
      .viewContactPickup(this.token, this.contactPickupId)
      .subscribe(
        (response) => {
          //console.log(response);
          if (response.status != "success") {
            if (response.longmsg) {
              this.showSwalLocations("error", response.msg, response.msg);
            } else {
              this.showSwalLocations("error", "ERROR!", response.msg);
            }
          } else {
            this.nameContactPickup = response.data.name;
            this.emailContactPickup = response.data.email;
            this.phoneContactPickup = response.data.phone;

            $("#myModalContactPickup").modal("show");
          }
          this.loading = false;
        },
        (error) => {
          console.log(<any>error);
          this.loading = false;
          this.showSwal("error");
        }
      );
  }

  deleteModalContact(contact) {
    this.contactPickupId = contact;
    $("#modalDeleteContact").modal("show");
  }

  deleteContactPickup() {
    this.saving = true;

    this._contactPartyPickupService
      .delete(this.token, this.contactPickupId)
      .subscribe(
        (response) => {
          if (response.status != "success") {
            if (response.longmsg) {
              this.showSwalLocations("error", response.msg, response.msg);
            } else {
              this.showSwalLocations("error", "ERROR!", response.msg);
            }
          } else {
            this.showSwalLocations(
              "success",
              "Contact removed!",
              "The contact has been removed successfully"
            );
            this.getContactPartyPickup();
          }
          $("#modalDeleteContact").modal("hide");
          this.saving = false;
        },
        (error) => {
          console.log(<any>error);
          this.saving = false;
          this.showSwal("error");
        }
      );
  }

  editContactPickupFunction() {
    this.saving = true;

    let json;

    json = {
      name: this.nameContactPickup,
      email: this.emailContactPickup,
      phone: this.phoneContactPickup,
      company: this.idUser,
    };

    this._contactPartyPickupService
      .editContactPickup(this.token, this.contactPickupId, json)
      .subscribe(
        (response) => {
          if (response.status != "success") {
            if (response.longmsg) {
              this.showSwalLocations("error", response.msg, response.msg);
            } else {
              this.showSwalLocations("error", "ERROR!", response.msg);
            }
          } else {
            $("#myModalContactPickup").modal("hide");
            this.showSwalLocations(
              "success",
              "Contact updated!",
              "The contact has been edited"
            );
            this.getContactPartyPickup();
          }
          this.saving = false;
        },
        (error) => {
          console.log(<any>error);
          this.saving = false;
          this.showSwal("error");
        }
      );
  }

  getContactPartyPickup() {
    this.loadingContacts = true;
    this._contactPartyPickupService
      .listByCompany(this.token, this.idUser)
      .subscribe(
        (r) => {
          if (r.status === "success") {
            this.contactsPartyPickup = r.data;
          } else {
            console.log(r.msg);
          }
          this.loadingContacts = false;
        },
        (error) => {
          console.log(<any>error);
          this.loadingContacts = false;
        }
      );
  }

  changePartyPickUp(e) {
    if (e.checked) this.enable3rd = true;
    else this.enable3rd = false;

    let json;

    json = {
      companies_id: Number(this.idUser),
      enablePartyPickup: this.enable3rd,
    };

    this._companylinkedService
      .setContactPartyPickup(this.token, json)
      .subscribe(
        (r) => {
          if (r.status === "success") {
            if (this.enable3rd) {
              this.showToast(
                "success",
                "3rd Party Pickups has been enabled",
                2000
              );
            } else {
              this.showToast(
                "success",
                "3rd Party Pickups has been disabled",
                2000
              );
            }
            console.log("Set Success");
          } else {
            console.log(r.msg);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }
  changeDefaultLocation(e) {
    if (e.checked) this.enableDefault = true;
    else this.enableDefault = false;

    if (this.enableDefault == true) {
      this.location.defaultLocation = 1;
    } else {
      this.location.defaultLocation = 0;
    }
  }

  changeVIP(e) {
    if (e.checked) this.enableVIP = true;
    else this.enableVIP = false;
    // if (e.checked) this.enableVIP = 1;
    // else this.enableVIP = 0;

    let json;

    json = {
      companies_id: Number(this.idUser),
      vipStatus: this.enableVIP,
    };

    this._companylinkedService.setContactVIP(this.token, json).subscribe(
      (r) => {
        if (r.status === "success") {
          if (this.enableVIP) {
            this.showToast("success", "Company has been saved as VIP", 2000);
          } else {
            this.showToast("success", "VIP status has been removed", 2000);
          }
        } else {
          console.log(r.msg);
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  addContactPickup() {
    let json;

    json = {
      name: this.nameContactPickup,
      email: this.emailContactPickup,
      phone: this.phoneContactPickup,
      company: this.idUser,
    };

    this.saving = true;
    this._contactPartyPickupService.newContact(this.token, json).subscribe(
      (response) => {
        console.log(response);
        if (response.status != "success") {
          if (response.longmsg) {
            this.showSwalLocations("error", response.msg, response.msg);
          } else {
            this.showSwalLocations("error", "ERROR!", response.msg);
          }
        } else {
          $("#myModalContactPickup").modal("hide");
          this.showSwalLocations(
            "success",
            "Contact added!",
            "A new contact has been added"
          );
          this.getContactPartyPickup();
        }
        this.saving = false;
      },
      (error) => {
        console.log(<any>error);
        this.saving = false;
        this.showSwal("error");
      }
    );
  }

  getStates(countryName) {
    console.log("countryname", countryName);
    let country_id = null;
    for (let country of this.countries) {
      if (country.name == countryName) {
        country_id = country.id;
        break;
      }
    }
    console.log("country id", country_id);
    this._taxService.showAll(country_id).subscribe(
      (r) => {
        console.log(r.data, "states");
        this.states = r.data;
        const coloniaAbbr = this.user.colonia?.split(" - ")[0]; // Extrae sólo "TX"
        const coloniaAbbrLoc = this.location.colonia?.split(" - ")[0]; // Extrae sólo "TX"
        const foundState = this.states.find((c) => c.abbr === coloniaAbbr);
        const foundStateLoc = this.states.find(
          (c) => c.abbr === coloniaAbbrLoc
        );
        if (foundStateLoc) {
          this.myControlStates.setValue(foundStateLoc);
        }
        if (foundState) {
          this.myControlStatesAddress.setValue(foundState);
        }
        this.filteredStates = this.myControlStates.valueChanges.pipe(
          startWith<string | UserList>(""),
          map((value) => (typeof value === "string" ? value : value.name)),
          map((name) => (name ? this._filterStates(name) : this.states.slice()))
        );
        this.filteredStatesAddress =
          this.myControlStatesAddress.valueChanges.pipe(
            startWith<string | UserList>(""),
            map((value) => (typeof value === "string" ? value : value.name)),
            map((name) =>
              name ? this._filterStates(name) : this.states.slice()
            )
          );
        console.log("jala los states", this.states);
        this.loadingStates = false;
        this.setStateBasedOnColonia();
      },
      (error) => {
        this.loadingStates = false;
      }
    );
  }
  public statesTax;
  public countryTax;
  getStatesTax() {
    this._taxService.showAll(1).subscribe((r) => {
      console.log(r, "mi r");
      if (r.status == "success") {
        this.statesTax = r.data;
      }
      console.log("aquiii", this.statesTax);

      this.loadingStates2 = false;
    });
  }

  getStates2(restartState = false) {
    console.log("se hace el change");
    this.loadingStates2 = true;
    this.states2 = [];

    if (restartState) {
      this.location.colonia = null;
    }
    let country_id = null;
    for (let country of this.countries) {
      if (country.value === this.location.country) {
        country_id = country.id;
      }
    }

    this._taxService.showAll(country_id).subscribe((r) => {
      this.states2 = r.data;
      this.loadingStates2 = false;
    });
  }

  changeTaxExempt(e) {
    console.log(e);
    if (e.checked) {
      this.user.taxExempt = 1;
    } else {
      this.user.taxExempt = 0;
      this.user.salesTaxNumber = "";
    }
  }

  validarCompany() {
    console.log(this.user.companyId);
    this._companylinkedService
      .validateCompany(this.token, this.user.companyId)
      .subscribe((r) => {
        console.log(r);
        this.valid = r;
      });
  }

  selectedFile: File;

  onFileChanged(event) {
    var xhr = new XMLHttpRequest();
    this.selectedFile = <File>event.target.files[0];
    let headers = new Headers({ "Content-Type": "multipart/form-data" });

    const uploadData = new FormData();
    uploadData.append("namefile", this.selectedFile, this.selectedFile.name);
    uploadData.append("idpaciente", this.idUser);
    uploadData.append("type", "PROFILEPIC");
    console.log(uploadData);

    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          //  console.log(xhr.response);
          let respuesta = JSON.parse(xhr.response);
          console.log(respuesta.status);
          console.log(respuesta.img);
        } else {
          console.log(xhr.response);
        }
      }
    };

    // xhr.open('POST', 'https://www.datalus.mx/projects/liposser/resources/receiver.php', true);
    //xhr.setRequestHeader('Authorization',token);
    xhr.send(uploadData);
  }

  public disableFiles;
  onTotalChanged(nuevoTotal: number) {
    nuevoTotal >= 1 ? (this.disableFiles = true) : (this.disableFiles = false);
  }

  getTerms() {
    this._termService.getTermsByCompany(this.token, this.idUser).subscribe(
      (response) => {
        console.log(response);
        if (response.status == "success") {
          this.terms = response.data;
        } else {
          console.log("Error");
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  getPurchassingTerms() {
    this._purchassingTermsService
      .getTermsByCompany(this.token, this.idUser)
      .subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            this.purchassingTerms = response.data;
          } else {
            console.log("Error");
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  getConditions() {
    this._conditionService
      .getConditionsByCompany(this.token, this.idUser)
      .subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            this.conditions = response.data;
          } else {
            console.log("Error");
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  getCurrencies() {
    this._currencyService
      .getCurrenciesByCompany(this.token, this.idUser)
      .subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            this.currencies = response.data;
          } else {
            console.log("Error");
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }
  public filtrosStaff = [];
  public mtds: Methods = new Methods();
  /* buscardata */
  getData(e = null) {
    console.log(e);
    this.cargando = true;
    this._route.params.forEach((params: Params) => {
      /* let page = + params['page'];
  
      if (!page) {
        page = 1;
      } */
      // "State",
      //   "Tax Excempt Registration Number",
      // "Actions",
      this.filtrosStaff = [
        null,
        {
          key: "id",
          title: "id",
          value: "",
          type: "contains",
          key_type: "id_type",
          type_options: [
            { value: "nofilter", name: "No Filter" },
            { value: "contains", name: "Contains" },
            { value: "startswith", name: "Starts With" },
            { value: "endswith", name: "Ends With" },
            { value: "equalto", name: "Equal To" },
            { value: "notcontain", name: "Does Not Contain" },
          ],
        },
        {
          key: "rep",
          title: "Rep Name",
          value: "",
          type: "contains",
          key_type: "rep_type",
          type_options: [
            { value: "nofilter", name: "No Filter" },
            { value: "contains", name: "Contains" },
            { value: "startswith", name: "Starts With" },
            { value: "endswith", name: "Ends With" },
            { value: "equalto", name: "Equal To" },
            { value: "notcontain", name: "Does Not Contain" },
          ],
        },
        {
          key: "title",
          title: "Title",
          value: "",
          type: "contains",
          key_type: "title_type",
          type_options: [
            { value: "nofilter", name: "No Filter" },
            { value: "contains", name: "Contains" },
            { value: "startswith", name: "Starts With" },
            { value: "endswith", name: "Ends With" },
            { value: "equalto", name: "Equal To" },
            { value: "notcontain", name: "Does Not Contain" },
          ],
        },
        {
          key: "name",
          title: "Name",
          value: "",
          type: "contains",
          key_type: "name_type",
          type_options: [
            { value: "nofilter", name: "No Filter" },
            { value: "contains", name: "Contains" },
            { value: "startswith", name: "Starts With" },
            { value: "endswith", name: "Ends With" },
            { value: "equalto", name: "Equal To" },
            { value: "notcontain", name: "Does Not Contain" },
          ],
        },
        {
          key: "state",
          title: "State",
          value: "",
          type: "contains",
          key_type: "state_type",
          type_options: [
            { value: "nofilter", name: "No Filter" },
            { value: "contains", name: "Contains" },
            { value: "startswith", name: "Starts With" },
            { value: "endswith", name: "Ends With" },
            { value: "equalto", name: "Equal To" },
            { value: "notcontain", name: "Does Not Contain" },
          ],
        },

        {
          key: "city",
          title: "City",
          value: "",
          type: "contains",
          key_type: "city_type",
          type_options: [
            { value: "nofilter", name: "No Filter" },
            { value: "contains", name: "Contains" },
            { value: "startswith", name: "Starts With" },
            { value: "endswith", name: "Ends With" },
            { value: "equalto", name: "Equal To" },
            { value: "notcontain", name: "Does Not Contain" },
          ],
        },
        {
          key: "type",
          title: "Type",
          value: "",
          type: "contains",
          key_type: "type_type",
          type_options: [
            { value: "nofilter", name: "No Filter" },
            { value: "contains", name: "Contains" },
            { value: "startswith", name: "Starts With" },
            { value: "endswith", name: "Ends With" },
            { value: "equalto", name: "Equal To" },
            { value: "notcontain", name: "Does Not Contain" },
          ],
        },
        null,
      ];
      this.staffData.rows = [];
      this.loading = "show";
      this._userService
        .getAllUsersType(
          this.token,
          "company" + this.idUser,
          e !== null ? (this.page = e.page) : (this.page = 1),
          "ALL",
          this.activos,
          1,
          [],
          e !== null ? (this.pageLimit = e.perPage) : (this.pageLimit = "10")
        )
        .subscribe(
          (response) => {
            this.pacientes = response.data;
            console.log(response);
            if (response.status == "success") {
              this.pacientes = response.data;
              this.page = Number(response.page_actual);
              this.totalItems = Number(response.total_items_count);
              this.totalPaginas = Number(response.total_pages);
              let selected_value = false;
              for (let element of response.data) {
                let actionButtons = [];

                actionButtons = [
                  {
                    icon: "remove_red_eye",
                    action: "Detail",
                    color: "info",
                  },
                ];
                if (element.activo == 1) {
                  actionButtons.push({
                    icon: "power_settings_new",
                    action: "Inactive",
                    color: "danger",
                  });
                } else {
                  actionButtons.push({
                    icon: "power_settings_new",
                    action: "Active",
                    color: "success",
                  });
                }

                this.staffData.rows.push([
                  new Cell(element.id, {
                    type: "checkbox",
                    selected: selected_value,
                  }), // Check box
                  new Cell(element.id),
                  new Cell(element.managedByString),
                  new Cell(element.ocupation),
                  new Cell(element.name + " " + element.surname),
                  new Cell(element.state || element.colonia),
                  new Cell(element.city),
                  new Cell(element.role),
                  new Cell(actionButtons, { type: "actions" }),
                ]);
              }

              this.loading = "hide";
            } else {
              localStorage.clear();
              this._router.navigate(["/pages/lock"]);
            }
            this.cargando = false;
          },
          (error) => {
            console.log(<any>error);
            this.cargando = false;
          }
        );
    });
  }

  /* buscar data */
  getAllPacientes() {
    this.filtrosStaff = [
      null,
      {
        key: "id",
        title: "id",
        value: "",
        type: "contains",
        key_type: "id_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "rep",
        title: "Rep Name",
        value: "",
        type: "contains",
        key_type: "rep_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "title",
        title: "Title",
        value: "",
        type: "contains",
        key_type: "title_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "name",
        title: "Name",
        value: "",
        type: "contains",
        key_type: "name_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "state",
        title: "State",
        value: "",
        type: "contains",
        key_type: "state_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },

      {
        key: "city",
        title: "City",
        value: "",
        type: "contains",
        key_type: "city_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "type",
        title: "Type",
        value: "",
        type: "contains",
        key_type: "type_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      null,
    ];
    this.tableUsers = false;
    this.pacientes = [];
    this.cargando = true;
    this.staffData.rows = [];
    this._route.params.forEach((params: Params) => {
      let page = +params["page"];

      if (!page) {
        page = 1;
      }

      this.loading = "show";
      console.log("company" + this.idUser);
      this._userService
        .getAllUsersType(
          this.token,
          "company" + this.idUser,
          this.page,
          "ALL",
          this.activos,
          1,
          [],
          this.pageLimit
        )
        .subscribe(
          (response) => {
            console.log(response);
            if (response.status == "success") {
              this.pacientes = response.data;
              this.page = Number(response.page_actual);
              this.totalItems = Number(response.total_items_count);
              this.totalPaginas = Number(response.total_pages);

              /*   this.dataTable = {
                headerRow: [
                  "ID",
                  "Rep Name",
                  "Company Name",
                  "Title",
                  "Name",
                  "City",
                  "State",
                  "Actions",
                  "Type",
                  "Status"
                ],
                footerRow: [
                  "ID",
                  "Rep Name",
                  "Company Name",
                  "Title",
                  "Name",
                  "City",
                  "State",
                  "Actions",
                  "Type",
                  "Status"
                ],

                dataRows: [],
              }; */

              /*               this.pacientes.forEach(
                function (element) {
                  let nameCompany = "";
                  if (element.companyLinked != null)
                    nameCompany = element.companyLinked.name;
                  this.dataTable.dataRows.push([
                    element.id,
                    element.managedByString,
                    nameCompany,
                    element.ocupation,
                    element.name + " " + element.surname,
                    element.city,
                    element.colonia,
                    "",
                    element.role,
                  ]);
                }.bind(this)

              ); */
              let nameCompany = "";
              for (let element of response.data) {
                let selected_value = false;

                if (this.bulkItems.includes(element.id.toString()))
                  selected_value = true;
                let actionButtons = [];

                actionButtons = [
                  {
                    icon: "remove_red_eye",
                    action: "Detail",
                    color: "info",
                  },
                ];
                if (element.activo == 1) {
                  actionButtons.push({
                    icon: "power_settings_new",
                    action: "Active",
                    color: "danger",
                  });
                } else {
                  actionButtons.push({
                    icon: "power_settings_new",
                    action: "Inactive",
                    color: "success",
                  });
                }
                if (element.companyLinked != null) {
                  nameCompany = element.companyLinked.name;
                }
                this.staffData.rows.push([
                  new Cell(element.id, {
                    type: "checkbox",
                    selected: selected_value,
                  }), // Check box
                  new Cell(element.id),
                  new Cell(element.managedByString),
                  new Cell(element.ocupation),
                  new Cell(element.name + " " + element.surname),
                  new Cell(element.state || element.colonia),
                  new Cell(element.city),
                  new Cell(element.role),
                  new Cell(actionButtons, { type: "actions" }),
                  // new Cell(element.activo == 1 ? "Active" : "Inactive", {
                  //   type: "action-button",
                  //   value: { id: element.id },
                  //   icon: "power_settings_new",
                  //   class:
                  //     element.activo == 1
                  //       ? "btn-success"
                  //       : "gts-btn-secondary ",
                  //   typeaction: element.activo == 1 ? "Active" : "Inactive",
                  // }),
                  // new Cell(
                  //   [
                  //     {
                  //       icon: "remove_red_eye",
                  //       action: "Detail",
                  //       color: "info",
                  //     },
                  //     {
                  //       icon: "remove_red_eye",
                  //       action: "",
                  //       color: "info",
                  //     },
                  //     {
                  //       icon: "remove_red_eye",
                  //       action: "Detail",
                  //       color: "info",
                  //     },
                  //   ],
                  //   { type: "actions" }
                  // ),
                ]);
              }
              this.loading = "hide";

              //total paginas
              /*               this.pages = [];
              for (let i = 0; i < response.total_pages; i++) {
                this.pages.push(i);
              }

              //pagina anterior
              if (page >= 2) {
                this.pagePrev = page - 1;
              } else {
                this.pagePrev = page;
              }

              //pagina siguiente
              if (page < response.total_pages) {
                this.pageNext = page + 1;
              } else {
                this.pageNext = page;
              } */
            } else {
              localStorage.clear();
              this._router.navigate(["/pages/lock"]);
            }
            this.cargando = false;
          },
          (error) => {
            console.log(<any>error);
            this.cargando = false;
          }
        );
    });

    this.tableUsers = true;
  }

  deleteFolderfirst(id) {
    swal
      .fire({
        title: "",
        text:
          "Do you want to make this user " +
          (this.activos === 1 ? "inactive" : "active"),
        icon: "info",
        showCancelButton: true,
        buttonsStyling: false,

        customClass: {
          confirmButton: "gts-btn-primary",
          cancelButton: "gts-btn-primary-outline",
        },
        confirmButtonColor: "#9c27b0",
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      })
      .then(
        function (result) {
          if (result.value) {
            this._userService.deleteUser(this.token, id).subscribe(
              (response) => {
                console.log(response);
                if (response.status === "success") {
                  this.getAllPacientes();
                  this.mtds.notifySuccess(
                    this.activos === 1
                      ? "Employee status has been changed to inactive"
                      : "Employee status has been changed to active"
                  );
                } else {
                  this.mtds.notifyError(response.msg, response.code);
                }
              },
              (error) => {
                this.mtds.notifyError(error.statusText, error.status);
              }
            );
          }
        }.bind(this)
      );
  }
  actions(e) {
    switch (e.action) {
      case "Detail":
        this._router.navigate(["/pages/user", e.id]);
        break;
      case "Active":
        this.deleteFolderfirst(e.id);
        break;
      case "Inactive":
        this.deleteFolderfirst(e.id);
        break;
      default:
        break;
    }
    console.log(e);
  }

  removeBulk() {
    this.actionsLoc({ action: "Remove" });
  }
  removeBulkStaff() {
    let json = {
      ids: this.bulkItems,
    };
    this._service.updateMultiple(this.token, json).subscribe((response) => {
      if (response.status === "success") {
        this.showToast("success", "Users has been deleted", 2000);
        this.getData();
      }
      this.loading = false;
    });
  }
  actionsLoc(e) {
    console.log(e, "action");
    switch (e.action) {
      case "Detail":
        this.openNewModal(e.id.id);
        // this._router.navigate(["/pages/user", e.id]);
        break;
      case "contacts":
        // console.log("se hace", e.id);
        this.openContactsModal(e.id);
        break;
      case "Remove":
        swal
          .fire({
            title: "",
            text:
              this.bulkItems.length !== 0
                ? "Are you sure to delete these locations?"
                : "Are you sure to delete this location?",
            showCancelButton: true,
            buttonsStyling: false,
            customClass: {
              confirmButton: "gts-btn-primary",
              cancelButton: "gts-btn-primary-outline",
            },
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Continue",
          })
          .then(
            function (result) {
              if (result.value) {
                if (this.bulkItems.length !== 0) {
                  this.deleteBulkLocations(this.bulkItems);
                } else {
                  this.locationId = e.id.id;
                  this.deleteLocation();
                }
              }
            }.bind(this)
          );
        // this.deleteModal(e.id.id);
        break;
      default:
        break;
    }
    console.log(e);
  }
  sexos = [
    { value: "0", viewValue: "Female" },
    { value: "1", viewValue: "Male" },
    { value: "2", viewValue: "Other" },
  ];
  showToast(type, title, timer) {
    const Toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = swal.stopTimer;
        toast.onmouseleave = swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: type,
      title: title,
    });
  }

  public listTax = [];
  public listLoc = [];
  getListTax() {
    // "State",
    //   "Tax Excempt Registration Number",
    // "Actions",
    this.filtros = [
      {
        key: "state",
        title: "State",
        value: "",
        type: "contains",
        key_type: "state_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "taxExemptRegistrationNumber",
        title: "Tax Excempt Registration Number",
        value: "",
        type: "contains",
        key_type: "taxExemptRegistrationNumber_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      null,
    ];
    this.loading = true;
    this.arraytax = [];
    this._taxService.listTaxExempt(this.idUser).subscribe((response) => {
      if (response.status === "success") {
        this.listTax = response.data;
        this.taxData.rows = [];
        this.paginaActualTax = Number(response.page_actual);
        this.itemsPorPaginaTax = String(response.items_per_page);
        this.totalItemsTax = Number(response.total_items_count);
        this.totalPaginasTax = Number(response.total_pages);

        for (let element of response.data) {
          let actionButtons = [];

          actionButtons = [
            {
              icon: "edit",
              action: "Edit",
              value: element,
              color: "warning",
            },

            {
              icon: "file_download",
              action: "Download",
              value: element,
              color: "primary",
            },
            {
              icon: "remove_red_eye",
              action: "View File",
              value: element,
              color: "info",
            },
            {
              icon: "delete_outline",
              action: "Remove",
              value: element,
              color: "danger",
            },
          ];

          this.taxData.rows.push([
            new Cell(element.state.name),
            new Cell(element.taxNumber),
            new Cell(actionButtons, { type: "actions" }),
          ]);
        }
      }
      this.loading = false;
    });
  }
  getListLocations() {
    // "State",
    //   "Tax Excempt Registration Number",
    // "Actions",
    this.filtrosLoc = [
      null,
      {
        key: "id",
        title: "id",
        value: "",
        type: "contains",
        key_type: "id_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "default",
        title: "Default",
        value: "",
        type: "contains",
        key_type: "default_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },

      {
        key: "name",
        title: "Name",
        value: "",
        type: "contains",
        key_type: "name_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "address",
        title: "Address",
        value: "",
        type: "contains",
        key_type: "address_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "address2",
        title: "Address 2",
        value: "",
        type: "contains",
        key_type: "address2_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "country",
        title: "Country",
        value: "",
        type: "contains",
        key_type: "country_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "state",
        title: "State",
        value: "",
        type: "contains",
        key_type: "state_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "city",
        title: "City",
        value: "",
        type: "contains",
        key_type: "city_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "zipcode",
        title: "Zip Code",
        value: "",
        type: "contains",
        key_type: "zipcode_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },

      null,
    ];
    this.loadingLocations = true;
    this.arrayLoc = [];
    this._locationService
      .getLocationsByCompany(this.token, this.idUser)
      .subscribe(
        (response) => {
          this.loadingLocations = false;
          // this.pacientes = response.data;
          console.log(response, "respuesta");

          if (response.status == "success") {
            this.listLoc = response.data;
            this.locationsData.rows = [];
            this.paginaActualLoc = Number(response.page_actual);
            this.itemsPorPaginaLoc = String(response.items_per_page);
            this.totalItemsLoc = Number(response.total_items_count);
            this.totalPaginasLoc = Number(response.total_pages);
            for (let element of response.data) {
              let actionButtons = [];
              let defaults = [];
              let selected_value = false;

              if (this.bulkItems.includes(element.id.toString()))
                selected_value = true;
              actionButtons = [
                {
                  icon: "edit",
                  action: "Detail",
                  value: element,
                  color: "warning",
                },
                {
                  icon: "people_alt",
                  action: "contacts",
                  value: element,
                  color: "info",
                },
                {
                  icon: "delete_outline",
                  action: "Remove",
                  value: element,
                  color: "danger",
                },
              ];
              defaults = [
                {
                  icon: "check_circle",
                  action: "",
                  value: element,
                  color: "info",
                },
              ];

              this.locationsData.rows.push([
                new Cell(element.id, {
                  type: "checkbox",
                  selected: selected_value,
                }), // Check box
                new Cell(element.id),

                element.defaultLocation == 1
                  ? new Cell("Default", {
                      color: "#333",
                      icon: "check_circle",
                    })
                  : new Cell(""),
                new Cell(element.name),
                new Cell(element.address),
                new Cell(element.address2),
                new Cell(element.country),
                new Cell(element.colonia ? element.colonia : element.state),
                new Cell(element.city),
                new Cell(element.zipCode),
                new Cell(actionButtons, { type: "actions" }),
              ]);
            }
            this.loadingLocations = false;
          } else {
            localStorage.clear();
            // this._router.navigate(["/pages/lock"]);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  public loadingLocations = false;
  public arrayLoc = [];
  public paginaActualLoc = null;
  public itemsPorPaginaLoc = null;
  public totalItemsLoc = null;
  public totalPaginasLoc = null;
  getDataLocations(e = null) {
    this.loadingLocations = true;
    console.log(e, "se carga aqui");
    this.cargando = true;
    this.locationsData.rows = [];
    this.loading = "show";
    this.filtrosLoc = [
      {
        key: "id",
        title: "id",
        value: "",
        type: "contains",
        key_type: "id_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "default",
        title: "Default",
        value: "",
        type: "contains",
        key_type: "default_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },

      {
        key: "name",
        title: "Name",
        value: "",
        type: "contains",
        key_type: "name_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "address",
        title: "Address",
        value: "",
        type: "contains",
        key_type: "address_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "country",
        title: "Country",
        value: "",
        type: "contains",
        key_type: "country_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "state",
        title: "State",
        value: "",
        type: "contains",
        key_type: "state_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "city",
        title: "City",
        value: "",
        type: "contains",
        key_type: "city_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "zipcode",
        title: "Zip Code",
        value: "",
        type: "contains",
        key_type: "zipcode_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },

      null,
    ];
    this._locationService
      .getLocationsByCompany(this.token, this.idUser)
      .subscribe(
        (response) => {
          this.loadingLocations = false;
          // this.pacientes = response.data;
          console.log(response, "respuesta");

          if (response.status == "success") {
            // this.pacientes = response.data;
            this.paginaActualLoc = Number(response.page_actual);
            this.totalItemsLoc = Number(response.total_items_count);
            this.totalPaginasLoc = Number(response.total_pages);
            let nameCompany = "";
            let defaults = [];
            for (let element of response.data) {
              if (element.companyLinked != null) {
                nameCompany = element.companyLinked.name;
              }
              defaults = [
                {
                  icon: "check_circle",
                  action: "Detail",
                  value: element,
                  color: "info",
                },
              ];
              this.locationsData.rows.push([
                new Cell(element.id),
                element.defaultLocation == 1
                  ? new Cell("Default", {
                      color: "#333",
                      icon: "check_circle",
                    })
                  : new Cell(""),

                new Cell(element.name),
                new Cell(element.name),
                new Cell(element.country),
                new Cell(element.colonia),
                new Cell(element.city),
                new Cell(element.zipCode),
              ]);
            }
            this.loading = "hide";
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
          this.cargando = false;
        },
        (error) => {
          console.log(<any>error);
          this.cargando = false;
        }
      );
  }

  public taxNumber;
  public state_id;
  public fileURL;
  public taxId;

  createTaxExempt() {
    this.loadingSave = true;
    let tax = {
      company_id: this.idUser,
      taxNumber: this.taxNumber,
      fileUrl: this.fileURL,
      state_id: this.state_id,
    };
    this._taxService.newTaxExempt(tax).subscribe(
      (response) => {
        console.log(response, "TAX");
        this.status_user = response.status;
        if (this.status_user !== "success") {
          // this.status_user = 'error';
        } else {
          this.newTaxEx = false;

          this.stepper.next();
          console.log(response, "resp tax");
          this.taxId = response.data.id;
          // this.showSwal('success-message');
          console.log("folder created");
          this.loadingSave = false;
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }
  public newTaxEx = false;
  public arraytax = [];
  public search = false;
  public filtros = [];
  public filtrosLoc = [];
  public pageTax = 1;
  public totalItemsTax = 0;
  public totalPaginasTax = 1;
  public paginaActualTax = 1;
  public itemsPorPaginaTax = "10";
  public config: Array<any> = [];
  public configLoc: Array<any> = [];
  public configStaff: Array<any> = [];

  public taxData: DinamicData = new DinamicData([
    "State",
    "Tax Excempt Registration Number",
    "Actions",
  ]);
  openTaxExempt() {
    $("#myModalTax").modal("show");
    this.newTaxEx = true;
    this.getStatesTax();
    this.isEdit = false;
  }
  getDataTax(e = null) {
    this.loading = true;
    this.arraytax = [];
    this._taxService.listTaxExempt(this.idUser).subscribe((response) => {
      if (response.status === "success") {
        this.taxData.rows = [];
        this.paginaActualTax = Number(response.page_actual);
        this.itemsPorPaginaTax = String(response.items_per_page);
        this.totalItemsTax = Number(response.total_items_count);
        this.totalPaginasTax = Number(response.total_pages);
        console.log(response);

        for (let element of response.data) {
          let actionButtons = [];

          actionButtons = [
            {
              icon: "edit",
              action: "Edit",
              value: element,
              color: "warning",
            },

            {
              icon: "file_download",
              action: "Download",
              value: element,
              color: "primary",
            },
            {
              icon: "remove_red_eye",
              action: "View File",
              value: element,
              color: "info",
            },
            {
              icon: "delete_outline",
              action: "Remove",
              value: element,
              color: "danger",
            },
          ];

          this.taxData.rows.push([
            new Cell(element.state.name),
            new Cell(element.taxNumber),
            new Cell(actionButtons, { type: "actions" }),
          ]);
        }
      }
      this.loading = false;
    });
  }
  removeTax(idTax, isClose = false) {
    if (isClose) {
      this._taxService.deleteTaxExempt(idTax).subscribe(
        (response) => {
          console.log(response);

          if (response.status === "success") {
            // this.showToast(
            //   "success",
            //   "Tax exemption has been deleted",
            //   2000
            // );
            this.getListTax();
            /*               this.mtds.notifySuccess(
          this.activos === 1 ? 'Truck status has been changed to inactive' : 'Truck status has been changed to active'
          ); */
          } else {
            this.mtds.notifyError(response.msg, response.code);
          }
        },
        (error) => {
          this.mtds.notifyError(error.statusText, error.status);
        }
      );
    } else {
      swal
        .fire({
          title: "",
          text: "Are you sure you want to remove this Tax Exemption? ",
          icon: "info",
          showCancelButton: true,
          buttonsStyling: false,

          customClass: {
            confirmButton: "gts-btn-primary",
            cancelButton: "gts-btn-primary-outline",
          },
          confirmButtonColor: "#9c27b0",
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
        })
        .then(
          function (result) {
            if (result.value) {
              this._taxService.deleteTaxExempt(idTax).subscribe(
                (response) => {
                  console.log(response);

                  if (response.status === "success") {
                    this.showToast(
                      "success",
                      "Tax exemption has been deleted",
                      2000
                    );
                    this.getListTax();
                    /*               this.mtds.notifySuccess(
                this.activos === 1 ? 'Truck status has been changed to inactive' : 'Truck status has been changed to active'
                ); */
                  } else {
                    this.mtds.notifyError(response.msg, response.code);
                  }
                },
                (error) => {
                  this.mtds.notifyError(error.statusText, error.status);
                }
              );
            }
          }.bind(this)
        );
    }
  }
  public editTax = false;
  actionTax(e) {
    console.log(e);
    switch (e.action) {
      case "Edit":
        this.detailTax(e.id.id, e);
        this.newTaxEx = true;
        this.editTax = true;
        $("#myModalTax").modal("show");
        break;

      case "Remove":
        this.removeTax(e.id.id);
        break;
      case "Download":
        this.download(e.id.id);
        break;
      case "View File":
        this.view(e.id.id);
        break;
      default:
        // this.downloadFile(e);
        break;
    }
  }
  actionLoc(e) {
    console.log(e);
  }

  viewFile(fileUrl: string) {
    window.open(fileUrl, "_blank");
  }
  download(id: number) {
    const tax = this.listTax.find((t) => t.id === id);
    if (tax?.fileUrl) {
      console.log("fileurl", tax.fileUrl);
      this.downloadFile(tax.fileUrl);
    }
  }

  view(id: number) {
    const tax = this.listTax.find((t) => t.id === id);
    if (tax?.fileUrl) {
      this.viewFile(tax.fileUrl);
    }
  }
  async downloadFile(fileUrl: string | { folder: string; file: string }) {
    if (typeof fileUrl === "object") {
      fileUrl = `https://ha-software.com/backend/${fileUrl.folder}/${fileUrl.file}`;
    }

    const fileName = fileUrl.substring(fileUrl.lastIndexOf("/") + 1);

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Limpia la URL creada en memoria
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  }
  public editId;
  public detailFile;
  public showMultiFiles = true;
  public isEdit = false;
  detailTax(id, e) {
    const tax = this.listTax.find((element) => {
      return element.id === id;
    });
    console.log(tax, "tax");
    this.detailFile = tax.fileUrl;
    this.state_id = tax.state?.id;
    this.taxNumber = tax.taxNumber;
    this.showMultiFiles = false;
    this.isEdit = true;
    this.taxId = tax.id;

    setTimeout(() => {
      this.showMultiFiles = true;
    }, 0);
  }
  closeTax() {
    if (this.taxId && !this.isEdit) {
      this.removeTax(this.taxId, true);
    }
    this.saveCloseTax();
  }

  saveCloseTax() {
    $("#myModalTax").modal("hide");

    this.showMultiFiles = false;
    setTimeout(() => {
      this.showMultiFiles = true;
      this.editTax = false;
      this.state_id = "";
      this.taxNumber = "";
      this.fileURL = "";
      this.detailFile = "";
      this.idCompany = "";
      this.taxId = "";
      this.disableFiles = false;
    }, 0);
    this.stepper.selectedIndex = 0;
  }
  public loadingSave = false;
  saveEditTax() {
    this.loadingSave = true;
    let tax = {
      company_id: this.idUser,
      taxNumber: this.taxNumber,
      fileUrl: this.detailFile
        ? encodeURIComponent(this.detailFile)
        : encodeURIComponent(
            "https://ha-software.com/backend/" +
              this.fileURL?.folder +
              "/" +
              this.fileURL?.file
          ),
      state_id: this.state_id,
    };
    this._taxService.editTaxExempt(this.taxId, tax).subscribe(
      (response) => {
        this.status_user = response.status;
        if (this.status_user !== "success") {
          // this.status_user = 'error';
        } else {
          this.newTaxEx = false;
          this.showToast(
            "success",
            "Tax Exemption has been save correctly ",
            2000
          );
          this.getListTax();
          this.editTax = false;
          this.saveCloseTax();

          this.showToast(
            "success",
            "Tax Exemption has been save correctly ",
            2000
          );
          this.getListTax();
          this.taxId = "";
          // this.showSwal('success-message');
          console.log("folder created");
          this.loadingSave = false;
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }
  updateConfig(e) {
    this.config = e;
    console.log(this.config);
    this._config.setConfig("taxList", this.config).subscribe((r) => {
      console.log(r);
    });
  }
  updateConfigStaff(e) {
    this.configStaff = e;
    console.log(this.configStaff);
    this._config.setConfig("staffTable", this.configStaff).subscribe((r) => {
      console.log(r);
    });
  }
  updateConfigLoc(e) {
    this.configLoc = e;
    this._config.setConfig("locationsList", this.configLoc).subscribe((r) => {
      console.log(r);
    });
  }
  openNuevoPaciente(): void {
    const user = new User(
      1,
      "customer",
      "",
      "",
      "",
      "demo123",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      0,
      "",
      1,
      1,
      1,
      "",
      0,
      "",
      "",
      "",
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      "",
      "",
      "",
      ""
    );
    let dialogRef = this.dialog.open(NuevoPaciente, {
      width: "80%",
      data: {
        user: user,
        sexos: this.sexos,
        company: this.idUser,
        role: "vendor",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getData();
      }
    });
  }
  public isVendor = false;
  public isCustomer = false;

  newVendor() {
    let user = new User(
      1,
      "VENDOR",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      0,
      "",
      1,
      1,
      1,
      "",
      0,
      "",
      "",
      "",
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      "",
      "",
      "",
      ""
    );
    let dialogRef = this.dialog.open(VendorComponent, {
      width: "80%",
      data: {
        user: user,
        sexos: [
          { value: "1", viewValue: "Hombre" },
          { value: "0", viewValue: "Mujer" },
        ],
        company: this.idUser,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      this.getAllPacientes();

      if (result) {
        this.getData();
        /*         this._service.newVendor(result).subscribe(
          (response: any) => {
            console.log(response);

            if (response.status === "success") {
              let userid = {
                name: "mad",
                value: response.user.id,
              };

              if (response.hasfolder == null) {
                let folderNEw = new Folder(
                  1,
                  response.user.companyLinked.name,
                  "",
                  "",
                  userid,
                  "",
                  0,
                  0,
                  1,
                  0
                );
                console.log(folderNEw);
                this._folderService
                  .create(JSON.parse(localStorage.getItem("token")), folderNEw)
                  .subscribe(
                    (response) => {
                      console.log(response);
                    },
                    (error) => {
                      console.log(<any>error);
                    }
                  );
              }

              this.getAllPacientes();

              swal.fire({
                title: "Vendor successfully added!",
                text: "",
                buttonsStyling: false,
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
            } else {
              swal.fire({
                title:
                  "Error! Something went wrong, it was not possible to add the user",
                text: response.msg,
                buttonsStyling: false,
                customClass: {
                  confirmButton: "btn btn-danger",
                },
              });
            }

            // this.getVendors();
          },
          (error) => {
            console.log(<any>error);
          }
        ); */
      }
    });
  }

  getLocations() {
    //this.loading = true;
    this._locationService
      .getLocationsByCompany(this.token, this.idUser)
      .subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            console.log(response.data);
            this.locations = response.data;

            // this.tableLocations = {
            //   headerRow: [
            //     "ID",
            //     "Name",
            //     "Address",
            //     "State",
            //     "City",
            //     "Zip Code",
            //     "Country",
            //     "Actions",
            //   ],
            //   footerRow: [
            //     "ID",
            //     "Name",
            //     "Address",
            //     "State",
            //     "City",
            //     "Zip Code",
            //     "Country",
            //     "Actions",
            //   ],
            //   dataRows: [],
            // };

            this.locations.forEach(
              function (element) {
                this.locationsData.dataRows.push([
                  element.id,
                  element.name,
                  element.address,
                  element.colonia,
                  element.city,
                  element.zipCode,
                  element.country,
                ]);
              }.bind(this)
            );
          } else {
            this.showSwalLocations("error", "ERROR!", response.msg);
          }
          //this.loading = false;
        },
        (error) => {
          console.log(<any>error);
          this.showSwalLocations("error");
          /*this.loading = false;*/
        }
      );
  }

  public isEditLocation = false;
  setLocation(e) {
    this.location.country = e;
    this.getStates(e);
    console.log(e, "e");
  }

  openNewModal(id: null) {
    if (id) {
      this.locationId = id;
      this.isEditLocation = true;
      this.showContactForm = true;
      this._locationService.getLocation(this.token, this.locationId).subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            this.location = response.data;
            console.log(this.location, "loc");
            this.location.companies_id = response.data.companyLinked.id;
            this.location.defaultLocation = parseFloat(
              this.location.defaultLocation
            );
            this.enableDefault =
              this.location.defaultLocation === 1 ? true : false;
            this.getCountries();
            // this.countryControl.setValue(this.location.country);

            $("#myModal").modal("show");
          } else {
            this.showSwalLocations("error", "ERROR!", response.msg);
          }
          this.loadinglocation = false;
        },
        (error) => {
          console.log(<any>error);
          this.showSwal("error");
          this.loadinglocation = false;
        }
      );
    } else {
      this.getCountries();
      this.myControlStates.setValue("");
      this.showContactForm = false;
      this.isEditLocation = false;
      $("#myModal").modal("show");
      this.location = new WareHouse();
    }
  }

  validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  newLocation() {
    let json;
    json = {
      companies_id: Number(this.idUser),
      name: this.location.name,
      address: this.location.address,
      address2: this.location.address2,
      colonia: this.location.colonia,
      city: this.location.city,
      zipCode: this.location.zipCode,
      country: this.location.country
        ? this.location.country
        : this.user.country,
      phone: this.location.phone,
      mobilePhone: this.location.mobilePhone,
      activo: this.location.activo,
      contactName: this.location.contactName,
      email: this.location.email,
      state: this.location.state,
      defaultLocation: this.location.defaultLocation,
    };

    this._locationService.newLocation(this.token, json).subscribe(
      (response) => {
        console.log(response);

        if (response.status == "success") {
          this.showToast(
            "success",
            "The location has been created succesfully.",
            2000
          );
          //window.location.href="/dashboard";
          $("#myModal").modal("hide");
          this.getListLocations();
          this.showContactForm = false;
          console.log("respuesta location", response);
          this.askContacts(response.data);
        } else {
          this.showSwalLocations("error", "ERROR!", response.msg);
        }
      },
      (error) => {
        console.log(<any>error);
        this.showSwalLocations("error");
      }
    );
  }

  askContacts(location) {
    swal
      .fire({
        title: "",
        text: "Do you Want to add contacts to this location now?",
        showCancelButton: true,
        buttonsStyling: false,

        customClass: {
          confirmButton: "gts-btn-primary",
          cancelButton: "gts-btn-primary-outline",
        },
        confirmButtonColor: "#9c27b0",
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      })
      .then(
        function (result) {
          if (result.value) {
            this.openContactsModal(location);
          }
        }.bind(this)
      );
  }

  openContactsCompany() {
    console.log(this.user);

    let dialogRef = this.dialog.open(ContactsComponent, {
      width: "70%",
      maxHeight: "80%",
      data: {
        id: this.user.id,
        name: this.user.name,
        type: "company",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
    });
  }

  openContactsModal(location) {
    console.log(location, "location");

    let dialogRef = this.dialog.open(ContactsComponent, {
      width: "70%",
      maxHeight: "80%",
      data: {
        id: location.id,
        name: location.name,
        type: "location",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
    });
  }

  openEditModal(id) {
    this.locationId = id;
    this.loadinglocation = true;
    this._locationService.getLocation(this.token, this.locationId).subscribe(
      (response) => {
        console.log(response);
        if (response.status == "success") {
          this.location = response.data;
          this.getStates2();
          $("#editModal").modal("show");
        } else {
          this.showSwalLocations("error", "ERROR!", response.msg);
        }
        this.loadinglocation = false;
      },
      (error) => {
        console.log(<any>error);
        this.showSwal("error");
        this.loadinglocation = false;
      }
    );
  }

  editLocation(id = null) {
    // this.location.country ? (this.location.country = this.user.country) : "";
    if (this.states.length > 0) {
      this.location.state = "";
    } else {
      this.location.colonia = "";
    }
    console.log("locationnnn", this.location);
    this._locationService
      .editLocation(this.token, id ? id : this.locationId, this.location)
      .subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            this.showToast(
              "success",
              "Location has been updated succesfully.",
              2000
            );
            //window.location.href="/dashboard";

            $("#myModal").modal("hide");
            this.getListLocations();
            this.myControlStates.setValue("");
            ("trigger");
          } else {
            this.showSwalLocations("error", "ERROR!", response.msg);
          }
        },
        (error) => {
          console.log(<any>error);
          this.showSwalLocations("error");
        }
      );
  }

  deleteModal(id) {}

  deleteLocation() {
    this._locationService.delete(this.token, this.locationId).subscribe(
      (response) => {
        console.log(response);
        if (response.status == "success") {
          this.showToast(
            "success",
            "The location has been deleted succesfully.",
            2000
          );
          //window.location.href="/dashboard";
          $("#modalDelete").modal("hide");
          this.getListLocations();
        } else {
          this.showToast("success", "Location has been deleted", 2000);
        }
      },
      (error) => {
        console.log(<any>error);
        this.showSwalLocations("error");
      }
    );
  }
  deleteBulkLocations(data) {
    const json = {
      bulk: data,
    };
    this._locationService.deleteBulk(this.token, json).subscribe(
      (response) => {
        console.log(response);
        if (response.status == "success") {
          this.showToast(
            "success",
            "The location has been deleted succesfully.",
            2000
          );
          //window.location.href="/dashboard";
          $("#modalDelete").modal("hide");
          this.getListLocations();
          this.bulkItems = [];
        } else {
          this.showToast("success", "Location has been deleted", 2000);
        }
      },
      (error) => {
        console.log(<any>error);
        this.showSwalLocations("error");
      }
    );
  }
  selectedState: any;
  setStateBasedOnColonia() {
    if (this.user.colonia.length <= 3) {
      const coloniaAbbr = this.user.colonia.split(" ")[0]; // "CA"

      this.selectedState = this.states.find(
        (state) => state.abbr === coloniaAbbr
      );

      if (this.selectedState) {
        this.user.colonia =
          this.selectedState.abbr + " - " + this.selectedState.name;
        console.log("Estado encontrado:", this.user.colonia);
      } else {
        console.log(
          "No se encontró ningún estado con la abreviatura:",
          coloniaAbbr
        );
      }
    }
  }
  ngAfterViewInit() {
    var self = this; // get a reference to `this`

    $("#datatables").DataTable({
      dom: "Bflrtip",
      buttons: [
        {
          extend: "copy",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "csv",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "excel",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "pdf",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "print",
          exportOptions: {
            columns: ":visible",
          },
        },
        "colvis",
      ],
      pagingType: "full_numbers",
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, "All"],
      ],
      responsive: true,
      language: {
        search: "_INPUT_",
        searchPlaceholder: "Search records",
      },
    });

    const table = $("#datatables").DataTable();

    $("#datatables2").DataTable({
      dom: "Bflrtip",
      buttons: [
        {
          extend: "copy",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "csv",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "excel",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "pdf",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "print",
          exportOptions: {
            columns: ":visible",
          },
        },
        "colvis",
      ],
      pagingType: "full_numbers",
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, "All"],
      ],
      responsive: true,
      language: {
        search: "_INPUT_",
        searchPlaceholder: "Search records",
      },
    });

    const table2 = $("#datatables2").DataTable();

    // Edit record
    table.on("click", ".edit", function () {
      console.log("entramos");
      const $tr = $(this).closest("tr");

      const data = table.row($tr).data();
      alert(
        "You press on Row: " +
          data[0] +
          " " +
          data[1] +
          " " +
          data[2] +
          "'s row."
      );
    });

    // Delete a record
    table.on("click", ".remove", function (e) {
      e.preventDefault();

      var txt;
      var r = confirm("Are you sure to delete this client?");
      if (r == true) {
        const $tr = $(this).closest("tr");
        const data = table.row($tr).data();

        table.row($tr).remove().draw();
        $("#borrarUser").val(data[0]);

        $("#borrarUser").trigger("click");
      } else {
      }
    });

    //Like record
    table.on("click", ".like", function () {
      console.log("like");
    });

    $(".card .material-datatables label").addClass("form-group");
  }

  animal: string =
    "Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium." +
    "Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugia";
  name: string;

  onSubmit() {
    console.log(this.user);
    this.user.industryType = this.industry;
    this._companylinkedService
      .update(this.token, this.user, this.idUser)
      .subscribe(
        (response) => {
          console.log(response);
          this.status_user = response.status;
          console.log(this.status_user);

          if (this.status_user != "success") {
            this.status_user = "error";
          } else {
            this.user = response.data;
            this.showToast(
              "success",
              "Company has been updated successfully.",
              2000
            );
            this.editAddress = false;
            this.editSettings = false;
            this.editCompany = false;
            this.updateToggleState(false);
            this.myControlUserCountries.disable();
            this.myControlStatesAddress.disable();
            // this.isEditCompany = true;
            // setTimeout(() => {
            //   this.isEditCompany = false;
            // });
            //this._router.navigate(['/task', this.task.id]);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }
  updateToggleState(newState: boolean) {
    this.isEditCompany = newState;
  }
  getTypeIndustry() {
    this._companyService.showAll().subscribe(
      (r) => {
        if (r.code === 400 && r.msg === "Authorization not valid") {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (r.status === "success") {
          this.industryTypes = r.data;
          console.log("industry", this.industryTypes);
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  getUser() {
    this.loading = "show";
    this._route.params.forEach((params: Params) => {
      console.log(params["id"], "companyid");
      let id = +params["id"];
      console.log(id);

      this._companylinkedService.getCompany(this.token, id).subscribe(
        (response) => {
          console.log(response, "user");
          if (response.status == "success") {
            this.user = response.data;
            // this.titleService.setTitle('Companies' + '/' + this.user.name);
            if (this.user) {
              this.enableVIP = this.user.vipStatus === 1 ? true : false;
            }
            if (!this.user.outstandingInvoiceDayLimit) {
              this.user.outstandingInvoiceDayLimit = "0";
            }
            if (!this.user.creditLimit) {
              this.user.creditLimit = "0.00";
            }
            if (this.user.enablePartyPickup) this.enable3rd = true;
            else this.enable3rd = false;

            this.titleServices.setBreadcrumbs([
              { label: "Companies", path: "/tables/listcompanies" },
              { label: this.user.name },
            ]);

            this.industry = this.user.industryType?.id || "";
            /* if(this.user.industryType.id!=null){
              this.industry = this.user.industryType.id;
            }else{
              this.industry = 0
            } */
            /* if(this.user.colonia == "TX "||this.user.colonia == "TX"){
              this.user.colonia = "TX - Texas"
              console.log("COLONIA!!!!!!!!!!!!")
            } */

            if (
              this.isValidDate(
                this.user?.certificationExpirationDate?.timestamp
              ) ||
              this.isValidDate(this.user?.certificationinitialdate?.timestamp)
            ) {
              this.stateDate = true;
              this.endDate = this.formatDate(
                this.user?.certificationExpirationDate?.timestamp
              );
              this.startDate = this.formatDate(
                this.user?.certificationinitialdate?.timestamp
              );
              this.start = this.startDate;
              this.end = this.endDate;
              this.active_inactive = this.user?.certificationactive;

              if (this.user?.certificationactive === 1) {
                this.stateDateCer = true;
              } else {
                this.stateDateCer = false;
              }
            } else {
              this.stateDate = false;
              this.endDate = null;
              this.startDate = null;
              this.start = this.startDate;
              this.end = this.endDate;
              this.active_inactive = this.user?.certificationactive;
            }
            this.getCountries();

            this.getStates(this.user.country);
            this.getStatesTax();
            this.loading = "hide";
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    });
  }

  showSwalLocations(type, title = "", message = "") {
    if (type === "success") {
      swal.fire({
        title: title,
        text: message,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    } else if (type === "error") {
      swal.fire({
        title: title,
        text: message,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }
  }

  showSwal(type) {
    if (type === "success-citas") {
      swal.fire({
        title: "Cita agendada con éxito!",
        text: "Has agendando una nueva cita.",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    } else if (type === "success-message") {
      swal.fire({
        title: "¡Success!",
        text: "User has been saved.",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    } else if (type === "warning-message-and-confirmation") {
      swal
        .fire({
          title: "Are you sure?",
          text: "You will not be able to revert this!",

          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false,
        })
        .then(function () {
          swal.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",

            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          });
        });
    } else if (type === "warning-message-and-cancel") {
      swal
        .fire({
          title: "Are you sure?",
          text: "You will not be able to recover this imaginary file!",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, keep it",
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          buttonsStyling: false,
        })
        .then(
          function () {
            swal.fire({
              title: "Deleted!",
              text: "Your imaginary file has been deleted.",

              customClass: {
                confirmButton: "btn btn-success",
              },
              buttonsStyling: false,
            });
          },
          function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === "cancel") {
              swal.fire({
                title: "Cancelled",
                text: "Your imaginary file is safe :)",

                customClass: {
                  confirmButton: "btn btn-info",
                },
                buttonsStyling: false,
              });
            }
          }
        );
    } else if (type === "custom-html") {
      swal.fire({
        title: "HTML example",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
        },
        html:
          "You can use <b>bold text</b>, " +
          '<a href="http://github.com">links</a> ' +
          "and other HTML tags",
      });
    } else if (type === "auto-close") {
      swal
        .fire({
          title: "Auto close alert!",
          text: "I will close in 2 seconds.",
          timer: 2000,
          showConfirmButton: false,
        })
        .then(
          function () {},
          // handling the promise rejection
          function (dismiss) {
            if (dismiss === "timer") {
              console.log("I was closed by the timer");
            }
          }
        );
    } else if (type === "input-field") {
      swal
        .fire({
          title: "Input something",
          html:
            '<div class="form-group">' +
            '<input id="input-field" type="text" class="form-control" />' +
            "</div>",
          showCancelButton: true,

          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          buttonsStyling: false,
        })
        .then(function (result) {
          swal.fire({
            html:
              "You entered: <strong>" + $("#input-field").val() + "</strong>",
            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          });
        });
    }
  }

  closeModal() {
    $("#modalCertified").modal("hide");
  }

  showDate(e: any): void {
    this.stateCert = false;
    if (this.user?.certificationactive === 1) {
      if (!e.checked) {
        this.stateModal = true;
        let dateExpiration = this.formatDateModal(
          this.user?.certificationExpirationDate?.timestamp
        );

        if (this.stateDateCer) {
          const fecha = new Date();
          const formatoYYYYMMDD = fecha.toISOString().split("T")[0];
          if (
            formatoYYYYMMDD >
            this.formatDateModal(
              this.user?.certificationExpirationDate?.timestamp
            )
          ) {
            this.endDate = formatoYYYYMMDD;
            dateExpiration = this.formatDateModal(
              this.user?.certificationExpirationDate?.timestamp
            );
          } else {
            console.log("fecha actual es menor a fecha expiration");
            const fecha = new Date(); // Ejemplo de fecha actual
            dateExpiration = formatoYYYYMMDD;
          }
        }
        this._locationService
          .addDateCertificate(
            this.token,
            this.idUser,
            dateExpiration,
            this.formatDateModal(
              this.user?.certificationinitialdate?.timestamp
            ),
            0,
            "update"
          )
          .subscribe(
            (r) => {
              this.stateDate = false;
              this.stateCert = false;
              this.stateModal = false;
              this.getUser();
            },
            (error) => {
              this.stateModal = false;
              console.error("Error en la petición:", error);
            }
          );
      }
    } else {
      if (e.checked) {
        this.active_inactive = 1;
        if (
          this.isValidDate(this.user?.certificationExpirationDate?.timestamp) ||
          this.isValidDate(this.user?.certificationinitialdate?.timestamp)
        ) {
          this.endDate = this.formatDateModal(
            this.user?.certificationExpirationDate?.timestamp
          );
          this.startDate = this.formatDateModal(
            this.user?.certificationinitialdate?.timestamp
          );
        }

        $("#modalCertified").modal("show");
      }
    }
  }

  editDate() {
    //this.getUser();
    if (
      this.isValidDate(this.user?.certificationExpirationDate?.timestamp) ||
      this.isValidDate(this.user?.certificationinitialdate?.timestamp)
    ) {
      this.endDate = this.formatDateModal(
        this.user?.certificationExpirationDate?.timestamp
      );
      this.startDate = this.formatDateModal(
        this.user?.certificationinitialdate?.timestamp
      );
      this.active_inactive = this.user?.certificationactive;
    } else {
      this.active_inactive = this.user?.certificationactive;
    }

    this.stateCert = false;

    $("#modalCertified").modal("show");
  }

  isValidDate(timestamp?: number | null): boolean {
    if (
      timestamp === undefined ||
      timestamp === null ||
      isNaN(timestamp) ||
      timestamp <= 0
    ) {
      return false;
    }

    const fixedTimestamp =
      timestamp < 10000000000 ? timestamp * 1000 : timestamp;
    const date = new Date(fixedTimestamp);
    return date instanceof Date && !isNaN(date.getTime());
  }

  chDate(date: string, position: number) {
    this.active_inactive = 0;
    if (position == 1) {
      this.startDate = date;
    } else if (position == 2) {
      this.endDate = date;
    }
  }

  dateCert() {
    this.stateCert = true;

    this.user?.certificationactive;
    this._locationService
      .addDateCertificate(
        this.token,
        this.idUser,
        this.endDate,
        this.startDate,
        Number(this.active_inactive),
        "update"
      )
      .subscribe(
        (r) => {
          if (r.status == "success") {
            this.stateDate = true;
            this.closeModal();
            this.getUser();
            //this.active_inactive = 1;
            // console.log('endDate ',this.endDate,' startDate ',this.startDate,' state ',this.active_inactive);
            this.stateCert = false;
          }
        },
        (error) => {
          this.stateCert = false;
          this.closeModal();
          console.log("Error ", error);
        }
      );
  }

  formatDateModal(timestamp: number): string {
    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Mes de 0 a 11, sumamos 1
    const day = String(date.getDate()).padStart(2, "0"); // Día del mes

    return `${year}-${month}-${day}`; // Retorna formato YYYY-MM-DD
  }

  formatDate(timestamp: number): string {
    const date = new Date(timestamp * 1000);
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Mes (getMonth() es base 0)
    const day = String(date.getDate()).padStart(2, "0"); // Día
    const year = date.getFullYear(); // Año

    return `${month}-${day}-${year}`;
  }
}
